// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__TesmV","image":"App_image__1-7ol"};